import {ExamModule, ModuleTopic} from '@cp/model';
import {useEffect, useState} from 'react';
import useListExamModules from '../examModules/useListExamModules';

export default function useExamModuleTopicSelector() {
  const {examModules, loading: modulesLoading} = useListExamModules();

  const [selectedTopic, setSelectedTopic] = useState<string | undefined>(undefined);
  const [selectedModuleId, setSelectedModuleId] = useState<string | undefined>(undefined);

  const [selectedModule, setSelectedModule] = useState<ExamModule | undefined>(undefined);
  const [selectedModuleTopic, setSelectedModuleTopic] = useState<ModuleTopic | undefined>(undefined);

  // extra steps and state to avoid issue where module id is set but exam modules are not loaded yet
  useEffect(() => {
    const module = (examModules ?? []).find((module) => module.id === selectedModuleId);
    setSelectedModule(module);
    setSelectedModuleTopic(module?.topics.find((t) => t.topic === selectedTopic));
  }, [examModules, selectedTopic, selectedModuleId]);

  return {
    examModules,
    modulesLoading,
    selectedModule,
    selectedTopic: selectedModuleTopic,
    setModuleById: setSelectedModuleId,
    setTopicByTopic: setSelectedTopic,
  };
}
